export const tagGroups = {
	title: "Grupo de Tags",
	total: "Total",
	exportToExcel: "Exportar a Excel",
	importConsumption: "Importar consumo",
	blockCards: {
		label: "Bloquear Tags Seleccionadas",
		confirmationMessage:
			"Está a punto de bloquear las tags seleccionadas. ¿Está seguro que desea continuar?",
		confirmationButton: "Sí, bloquear tags",
	},
	unblockCards: {
		label: "Activar Tags Seleccionadas",
		confirmationMessage:
			"Está a punto de activar las tags seleccionadas. ¿Está seguro que desea continuar?",
		confirmationButton: "Sí, activar tags",
	},
	filter: {
		zigCode: {
			label: "Filtrar por Zig Code",
			placeholder: "Zig Code",
		},
		group: {
			label: "Filtrar por grupo",
			placeholder: "Nombre del Grupo",
		},
		serial: {
			label: "Filtrar por Serial",
			from: "De:",
			to: "Hasta:",
			placeholderFrom: "Ej: 1001",
			placeholderTo: "Ej: 2001",
		},
		status: {
			label: "Filtrar por Estado",
			options: {
				all: "Todos",
				blocked: "Bloqueados",
				inUse: "En uso",
				used: "Anexado",
				inactive: "Inactivo",
			},
		},
		userType: {
			label: "Por Tipo de Usuario",
			options: {
				all: "Todos",
				anonymous: "Anónimo",
				nonAnonymous: "No Anónimo",
			},
		},
	},
	table: {
		export: {
			fileName: "grupo-de-tarjetas-del-evento-{{eventName}}_{{eventDate}}",
			titleName: "Grupo de Tarjetas del evento {{eventName}}",
		},
		selectedItems: "Elementos seleccionados:",
		columns: {
			zigCode: "Zig Code",
			serialNumber: "Serial",
			status: {
				label: "Estado",
				blocked: "Bloqueado",
				inUse: "En uso",
				used: "Anexado",
				inactive: "Inactivo",
			},
			user: {
				label: "Usuario",
				anonymous: "Anónimo",
			},
			zigDeviceGroup: "Grupo de Tarjeta",
			totalValue: "Saldo",
			actions: {
				label: "Acciones",
				block: "Bloquear",
				blockCard: "Bloquear Tarjeta",
				unblock: "Desbloquear",
				unblockCard: "Desbloquear Tarjeta",
				addConsumption: "Agregar consumo",
			},
		},
	},
	addConsumption: {
		title: "Agregar consumo",
		confirmButton: "Confirmar",
		fields: {
			rechargeType: {
				label: "Tipo de Recarga",
			},
			balanceValue: {
				label: "Valor de Recarga",
				required: "El valor de recarga debe ser mayor que cero",
			},
			reason: {
				label: "Motivo",
				required: "Informe el motivo",
			},
		},
	},
	topUpCancelation: {
		confirmation: {
			title: "Confirmar Cancelación de Recargas Pendientes",
			description:
				"Está a punto de cancelar todas las recargas pendientes asociadas a esta tarjeta. ¿Confirma la cancelación?",
			confirmButton: "Confirmar Cancelación",
			cancelButton: "Volver",
		},
		confirmationByBatch: {
			title: "Confirmar Cancelación en Lote de Recargas Pendientes",
			description:
				"Está a punto de cancelar todas las recargas pendientes asociadas a las tarjetas seleccionadas. ¿Confirmar la cancelación en lote?",
			confirmButton: "Confirmar Cancelación",
			cancelButton: "Volver",
		},
		cancelationButton: "Cancelar recargas pendientes",
	},
};
